import globalNewCar from "@/helpers/globalNewCar";

export default {
    computed: {
        brand_url() {
            const pageUrl = '/' + this.$route.path.split('/')[1]
            return pageUrl + globalNewCar.setUrlParams({brands: [this.car.brand_id]});
        },
    },
    methods:{
        setUrlParams(params) {
            //let d = window.btoa(JSON.stringify(params));
            //let d = JSON.stringify(params);
            let url = "?" + new URLSearchParams(params).toString()
            return url;
        },
    }
}